import React from 'react';
import { StatusAttentionIcon, WarningTriangleIcon } from '../icons';
import { CompilerStepState } from './CompilerStepsValidator';

interface StepTabHeaderProps {
  title: string;
  state: CompilerStepState | undefined;
}

const StepTabHeader: React.FC<StepTabHeaderProps> = ({ title, state }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
    <span>{title}</span>
    {/* Await design decision on whether we want to show warning state in the tab header.
    {state === 'error' && <StatusAttentionIcon />}
    {state === 'warning' && <WarningTriangleIcon />} */}
  </span>
);

export default StepTabHeader;
